import { TranslationKey } from 'providers/i18n/types';

export const ExportTypes = {
  Excel: 'xlsx',
  CSV: 'csv',
} as const;

export type ExportType = (typeof ExportTypes)[keyof typeof ExportTypes];

export const EXPORT_TYPE_NAMES: Record<ExportType, string> = {
  [ExportTypes.Excel]: 'Excel',
  [ExportTypes.CSV]: 'CSV',
} as const;

export type ExportTypeNames = (typeof EXPORT_TYPE_NAMES)[keyof typeof EXPORT_TYPE_NAMES];

export const enum ReportNames {
  Cumulative = 'cumulative_report',
  Orders_report = 'orders/report',
  Balance = 'balance_report',
  Orders = 'orders',
  ExpenseReport = 'expense_report',
  Order_adjustment_report = 'order_adjustments_report',
  Refund_chargeback_report = 'refund_chargeback_report',
  Bank_Operations_Pending_Statuses = 'bank_operations/pending_statuses',
  Bank_Operation_Final_Statuses = 'bank_operations/final_statuses',
}

export const enum ExportJobTypes {
  Cumulative = 'export_cumulative',
  Success_transaction = 'export_success_transactions',
  Orders = 'export_orders',
  Balance = 'export_balance',
  Adjustments = 'export_adjustment',
  Refund_chargeback = 'export_refund_chargeback',
  ExportExpenseReport = 'export_expense_report',
  Bank_Operation_Pending_Statuses = 'bank_operation_pending_statuses',
  Bank_Operation_Final_Statuses = 'bank_operation_final_statuses',
  ImportApproveExport = 'import_file_approve_export',
  ImportRejectExport = 'import_file_reject_export',
}

export const enum ExportTransportTypes {
  Email = 'email',
  Admin = 'admin_panel',
}

export const EXPORT_REPORT_NAMES: Record<ExportJobTypes, TranslationKey> = {
  [ExportJobTypes.Cumulative]: 'app.notificationPopper.reportNames.cumulative',
  [ExportJobTypes.Orders]: 'app.notificationPopper.reportNames.orders',
  [ExportJobTypes.Success_transaction]: 'app.notificationPopper.reportNames.transactions',
  [ExportJobTypes.Balance]: 'app.notificationPopper.reportNames.balance',
  [ExportJobTypes.Adjustments]: 'app.notificationPopper.reportNames.ordersAdjustment',
  [ExportJobTypes.Refund_chargeback]: 'app.notificationPopper.reportNames.refundChargeback',
  [ExportJobTypes.ExportExpenseReport]: 'app.notificationPopper.reportNames.expenseReport',
  [ExportJobTypes.Bank_Operation_Final_Statuses]:
    'app.notificationPopper.reportNames.bankOperationFinalStatuses',
  [ExportJobTypes.Bank_Operation_Pending_Statuses]:
    'app.notificationPopper.reportNames.bankOperationPendingStatuses',
  [ExportJobTypes.ImportApproveExport]: 'app.notificationPopper.reportNames.importApproveExport',
  [ExportJobTypes.ImportRejectExport]: 'app.notificationPopper.reportNames.importRejectExport',
};

export const EXPORT_REPORT_DESCRIPTIONS: Partial<Record<ExportJobTypes, TranslationKey>> = {
  [ExportJobTypes.ImportApproveExport]:
    'app.notificationPopper.reportDescriptions.importApproveExport',
  [ExportJobTypes.ImportRejectExport]:
    'app.notificationPopper.reportDescriptions.importRejectExport',
};
